import { Component, OnDestroy, inject } from '@angular/core';
import {StorageKeys} from '@app/core/constants/storage-keys';
import {LocalStorageService} from '@app/core/services/local-storage.service';
import {ILanguage} from '@app/shared/models/language.model';
import {selectActiveLanguages} from '@app/shared/state/language/language.selector';
import {Store} from '@ngrx/store';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {Subject, takeUntil, tap} from 'rxjs';
import { LoginInfoComponent } from '../../../shared/components/login-info/login-info.component';
import { Bind } from 'primeng/bind';
import { Button } from 'primeng/button';
import { LanguageSelectorComponent } from '../../../shared/components/language-selector/language-selector.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
    imports: [
        LoginInfoComponent,
        Bind,
        Button,
        LanguageSelectorComponent,
        TranslatePipe,
    ],
})
export class UnauthorizedComponent implements OnDestroy {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly localStorageService = inject(LocalStorageService);
  private readonly store = inject(Store);

  activeLanguages: ILanguage[] = [];
  private readonly unsubscribe$ = new Subject<void>();

  constructor() {
    this.store
      .select(selectActiveLanguages)
      .pipe(
        takeUntil(this.unsubscribe$),
        tap(languages => {
          this.activeLanguages = languages ?? [];
        })
      )
      .subscribe();
  }

  onLogoutClicked() {
    this.oidcSecurityService.logoffAndRevokeTokens().subscribe(() => {
      this.localStorageService.removeItem(StorageKeys.selectedOrganization);
      this.activeLanguages.forEach(language => {
        this.localStorageService.removeItem(`LocalizedProperties_${language.id}`);
      });
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
